import {AccountOption} from '@/app/account/shared/option/account.option';

export namespace Option {
  export import ACCOUNT = AccountOption;
}
